<template>
	<div class="page">
		<!-- <Tip :tip="tip" /> -->
		<TopTab :list='tabList' :tabIndex='tabIndex' @tabClick='tabClick' v-if="!loginInfo.supplier_id && !supplierBoolean" />
		<div class="screen_div">
			<el-input class="input" v-model="screen.good_name" size="medium" placeholder="商品名称" clearable />
			<el-select class="select" style="width: 140px;" v-model="screen.supplier_id" size="medium" filterable clearable placeholder="供货商家名称" @visible-change='selectSupplier'>
                <el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in supplierArr" :key="item.supplier_id" :label="item.supplier_name" :value="item.supplier_id" />
			</el-select>
            <el-select class="select" v-model="screen.good_type" size="medium" filterable clearable placeholder="商品类型">
				<el-option label="标准商品" value="1" />
                <!-- <el-option label="虚拟商品" value="2" /> -->
                <!-- <el-option label="技能服务" value="3" /> -->
                <el-option label="定制商品" value="4" />
                <el-option label="礼品" value="5" />
                <el-option label="赠品" value="6" />
			</el-select>
			<el-select class="select" v-model="screen.brand_id" size="medium" filterable clearable placeholder="商品品牌" @visible-change='selectBrand'>
                <el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in brandArr" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
			</el-select>
			<el-select class="select" v-model="screen.state" size="medium" placeholder="上下架状态">
                <el-option :key="0" label="全部" :value="0" />
				<el-option :key="1" label="上架" :value="1" />
                <el-option :key="2" label="下架" :value="2" />
			</el-select>

      <el-select v-model="screen.source_label_name" filterable placeholder="请选择上游标签" size="medium" >
        <el-option label="上游标签" value=""></el-option>
        <el-option v-for="label in source_label" :key="label" :label="label" :value="label"></el-option>
      </el-select>

			<el-button @click="getGoodList" size="medium" style="margin-left: 10px;">筛选</el-button>
			<el-button type="success" size="medium" v-if="!loginInfo.supplier_id" v-permit="'/admin/good/add'" @click="open(-1)">+添加自营商品</el-button>
            <el-button type="success" size="medium" v-if="loginInfo.supplier_id" @click="open(-1)">+添加商品</el-button>
			<!-- <el-button type="success" size="medium" v-if="!loginInfo.supplier_id" v-permit="'/admin/goodsCate/add'" @click="open(-1,'goodCategoryEdit')">+分类管理</el-button> -->
			<el-button type="danger" size="medium" v-if="!loginInfo.supplier_id && tabIndex!=0 &&tabIndex!=2" v-permit="'/admin/good/asyncSupply'" @click="syncClick()">一键同步供应链商品</el-button>
			<!-- <el-button type="danger" v-if="!loginInfo.supplier_id">一键同步供应链分类</el-button> -->
		</div>
		<div class="classify_div">
			<Classify :list='ClassifyList' @cateClick="cateClick" />
			<el-divider class="el-divider" direction="vertical" />
			<div class="from_div">
				<el-table ref="multipleTable" class="table_div" v-loading="loading"
					:data="tableData"
					:header-cell-style="tabStyle" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="80"/>
					<el-table-column label="商品信息" min-width="400">
						<template slot-scope="scope">
							<div class="row" style="align-items: center;">
								<img class="logo_img" :src="scope.row.cover_img != '' ? scope.row.cover_img : img" />
								<div class="col" style="margin-left: 20px;">
									<span>ID：{{ scope.row.good_id }}</span>
									<span>名称：{{ scope.row.good_name }}</span>
									<span>供货：{{ scope.row.good_source_text }}</span>
									<span>状态：{{ scope.row.state_text }}</span>
									<span>排序：{{ scope.row.sort }}</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="分类/销量" min-width="200">
						<template slot-scope="scope">
							<div class="col">
                                <div class="row">
									<span>类型：</span>
									{{scope.row.good_type_text}}
								</div>
								<div class="row">
									<span>分类：</span>
									<div class="col">
										<span v-for="(item,index) in scope.row.good_cate">{{item.cate1}}/{{item.cate2}}</span>
									</div>
								</div>
								<div class="row">
									<span>品牌：</span>
									<div class="col">
										<span v-for="(item,index) in scope.row.good_brand">{{item.brand1}}/{{item.brand2}}</span>
									</div>
								</div>
								<div class="row">
									<span>标签：</span>
									<span v-for="(item,index) in scope.row.tags">{{item}} </span>
								</div>
                                <div class="row" v-if="scope.row.good_source == 3">
                                    <span>上游标签：</span>
                                    <span >{{scope.row.source_label}}</span>
                                </div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="商品规格-定价" min-width="200">
						<template slot-scope="scope">
							<div class="col">
								<span v-for="(item,index) in scope.row.skus">
									{{item.spec_data_str}}, 本：{{item.cost_price}}, 售：{{item.sale_price}}, {{item.state_text}}
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180">
						<template slot-scope="scope">
							<el-button class="item_btn" size="mini" type="primary" v-permit="'/admin/good/edit'" @click="open(scope.row.good_id)">编辑</el-button>
							<el-button class="item_btn" size="mini" type="warning" v-permit="'/admin/good/state'" @click="set(scope.row.state,scope.row.good_id)">{{scope.row.state == 1 ? '下架':'上架'}}</el-button>
							<el-button class="item_btn" size="mini" type="success" v-permit="'/admin/good/sort'">排序</el-button>
							<el-button class="item_btn" size="mini" type="danger" v-permit="'/admin/good/del'" @click="del(scope.row.good_id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!--弹出层-->
		<Popup :name="name" :type="good_id" :show="show" @close='close' />
		<div class="foot_div">
			<div class="btn_div">
				<el-button @click="toggleSelection(1)">全选</el-button>
				<el-button type="danger" @click="toggleSelection(0)">清空选择</el-button>
				<el-button type="primary">
					<el-dropdown placement="top" @command="handleCommand">
						<span class="el-dropdown-link">功能<i class="el-icon-caret-right"></i></span>
						<el-dropdown-menu slot="dropdown" class="dropdown-menu">
                            <el-dropdown-item v-permit="'/admin/good/state'" command="1">批量上架</el-dropdown-item>
                            <el-dropdown-item v-permit="'/admin/good/state'" command="2">批量下架</el-dropdown-item>
                            <el-dropdown-item v-permit="'/admin/good/del'" command="3">批量删除</el-dropdown-item>
                            <!-- <el-dropdown-item command="4">批量提审</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>
				</el-button>
			</div>
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
    import {
		mapGetters
	} from 'vuex';
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		delTip
	} from "../../../../src/common/store/util.js"
	import TopTab from "../../../components/TopTab/TopTab.vue"
	import Classify from "../../../components/Classify/Classify.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import {
		goodLists,
		goodsCateLists,
		goodDel,
		goodState,
		goodAsyncSupply,
        supplierLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			TopTab,
			Classify,
			Popup
		},
		data() {
			return {
				tip: '综合对公司商品库的管理。平台自营商品需创建，供应链商品从接口获取，供应商商品由供应商上传，礼卡从商城创建。',
				img: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
				tabList: ['平台自营商品', '供应链商品', '供应商商品', '全部'],
                tabMap: [1, 3, 4, 0],
				tabIndex: 0,
				good_id: -1,
				options: [],
                source_label: [],
				value:'',
				ClassifyList: [], //分类列表
                supplierArr: [],
                brandArr: [],
				screen: {
					good_id: '', //商品id
					good_name: '', //商品名称
					brcode: '',
					cate_id: '',
					brand_id: '',
                    good_type: '',
          source_label_name: '',
          supplier_id: '',
					state: '',
					good_source: 1,
					tag_id: '',
					sort: '',
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
				total: 0,
                loading: false,
				tableData: [],
				name: '',
				show: false,
				multipleSelection: [],
				supplierBoolean:false
			}
		},
		
		
		// watch: {
		// 	'$route'(to, from) {
		// 		console.log('=as===',from)
		// 		if(to.meta.href == '/supplier'){
		// 			 // 在DOM更新之后执行异步操作
		// 			 this.supplierBoolean = true
		// 			 this.screen.good_source = 4
		// 		}else if(to.meta.href == '/sourceGoods'){
		// 			this.supplierBoolean = false
		// 			this.screen.good_source = 4
		// 		}
		// 	}
		// },
		
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			},
            ...mapGetters(['loginInfo']),
		},
		mounted() {
			this.upDate();
			this.getGoodsCateList();
			this.getGoodList();
		},
		methods: {
			
			//更新
			upDate(){
				const currentRoute = this.$router.currentRoute
				if(currentRoute.meta.href == '/supplier'){
					this.supplierBoolean = true
					this.screen.good_source = 4
					
				}else if(currentRoute.meta.href == '/sourceGoods'){
					this.supplierBoolean = false
					this.screen.good_source = 1
				}
			},
			
			//获取分类列表
			getGoodsCateList() {
				goodsCateLists({
					cate_type: '1'
				}).then(res => {
					if (res.code == 0) {
                        this.ClassifyList = [{cate_id: 0, cate_name: '全部'}, ...res.data];
					}
				}).catch(err => {})
			},

			//获取商品列表
			getGoodList() {
                this.loading = true;
				goodLists({
					...this.screen
				}).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count;
						this.tableData = res.data;
						this.source_label = res.other.source_label_arr;
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
			},
			
			//一键同步供应链商品
			syncClick(){
				goodAsyncSupply().then(res=>{
					if(res.code == 0){
						this.$message.success(res.msg);
						this.getGoodList();
					}else{
						this.$message.error(res.msg);
					}
				})
			},

			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getGoodList();
			},

			tabClick(index) {
				this.tabIndex = index
                this.screen.good_source = this.tabMap[index];
                this.screen.page = 1;
                this.getGoodList();
			},

            cateClick(cate_id) {
                console.log('cateClick', cate_id)
                this.screen.cate_id = cate_id;
                this.screen.page = 1;
                this.getGoodList();
			},

            async selectSupplier(query) {
                if (!query) {
                    return false;
                }
                const res = await supplierLists()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.supplierArr = res.data;
            },

            async selectBrand(query) {
                if (!query) {
                    return false;
                }
                const res = await goodsCateLists({cate_type: 3, cate_pid: 0, limit: 100})
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.brandArr = res.data;
            },

			//删除操作
			del(good_id) {
				var ids = typeof(good_id) == 'number' ? [good_id] : good_id;
				delTip(this, '此操作将永久删除商品数据, 是否继续?', '提示').then(res => {
					if (res == 0) {
						goodDel({
							ids: ids
						}).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.getGoodList();
							} else {
								this.$message.error(res.msg);
							}
						}).catch(err => {})
					}
				})
			},

			//商品上下架
			set(state, good_id) {
				var ids = [good_id];
				if (state == 1) {
					//下架
					delTip(this, '商品下架后将不能展示与销售, 是否继续?', '提示').then(res => {
						if (res == 0) {
							this.getGoodState(2, ids);
						}
					})
				} else {
					//上架
					this.getGoodState(1, ids);
				}
			},

			//商品上下架
			getGoodState(state, ids) {
				var data = {
					ids: ids,
					state: state
				}
				goodState({
					...data
				}).then(res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.tableData = [];
						this.getGoodList();
					} else {
						this.$message.error(res.msg);
					}
				})
			},

			open(good_id,name='productLibraryEdit') {
				this.good_id = good_id;
				this.name = name;
				this.show = true
			},

			close(type) {
				if (type == 0) {
					this.getGoodList();
				}
				this.show = false
			},

			toggleSelection(rows) {
				if (rows == 0) {
					//清空选项
					this.$refs.multipleTable.clearSelection();
				} else if (rows == 1) {
					//全选
					this.$refs.multipleTable.toggleAllSelection();
				} else {
					//单选
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				}
			},

			handleSelectionChange(val) {
				this.multipleSelection = val.map(obj => obj.good_id);
			},

			handleCommand(command) {
				if (this.multipleSelection.length == 0) {
					this.$message({
						message: '请选中需要批量处理的商品！',
						type: 'warning'
					});
					return
				}
				switch (command) {
					case 1:
						//批量上架
						this.getGoodState(command, this.multipleSelection);
						break;
					case 2:
						//批量下架
						delTip(this, '商品下架后将不能展示与销售, 是否继续?', '提示').then(res => {
							if (res == 0) {
								this.getGoodState(command, this.multipleSelection);
							}
						})
						break;
					case 3:
						//批量删除
						this.del(this.multipleSelection);
						break;
					case 4:
						//批量提审
						break;
				}
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

    .input {
		width: 200px;
        margin-right: 13px;
	}
	
	.logo_img{
		width: 60px;
		height: 60px;
		border-radius: 100%;
		border: 1px solid #f5f5f5;
		background: #fff;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 10px;
	}

	.select {
		width: 128px;
		margin-right: 13px;
	}

	.classify_div {
		display: flex;
		flex-direction: row;
		margin-top: 20px;
		/* height: 540px; */
		max-height: 100%;
	}

	.from_div {
		width: calc(100% - 100px);
		overflow: scroll;
	}

	.table_div {
		width: 100%;
	}

	.table_div::before {
		height: 0;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 0 5px 0 0;
	}
	
	/*伪类样式*/
	.item_btn:nth-child(3) {
		margin-top: 5px;
	}

	.foot_div {
		position: absolute;
		display: flex;
		justify-content: space-between;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.el-divider--vertical {
		height: 540px;
	}

	.btn_div {
		display: flex;
		margin-top: 15px;
		height: 40px;
	}

	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}

	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}

	.dropdown-menu {
		margin-bottom: 25px !important;
	}
</style>